'use client';

interface ErrorViewProps {
  msg: string | null;
  onReset: () => void;
}

export function ErrorView({ msg, onReset }: ErrorViewProps) {
  return (
    <div className="flex min-h-screen items-center justify-center px-6 pt-20 pb-24">
      <div className="w-full max-w-md">
        <p className="font-mono text-[10px] tracking-widest text-error-text mb-4">
          SYSTEM // ERROR
        </p>
        <p className="text-sm text-on-surface-variant border-l-2 border-error-text pl-4 py-2 mb-6 leading-relaxed">
          {msg ?? 'An unexpected error occurred.'}
        </p>
        <button
          onClick={onReset}
          className="font-mono text-[11px] tracking-widest text-on-surface-variant hover:text-primary active:scale-95 transition-all"
        >
          &#8592; Try again
        </button>
      </div>
    </div>
  );
}
